import { FunctionalComponent, h } from "@stencil/core";
import { Bundle } from "../../services/i18n";
import { transformPrice } from "./search-utils";

interface ProductPriceProps {
  i18n: Bundle;
  retailPrice: number;
  installmentPrice: number | undefined;
}

export const ProductPrice: FunctionalComponent<ProductPriceProps> = ({
  i18n,
  retailPrice,
  installmentPrice,
}) => {
  if (!retailPrice && !installmentPrice) {
    return undefined;
  }

  return (
    <span class="product-price">
      {installmentPrice ? (
        <span class="product-price__from-label">{i18n.t("FROM") + " "}</span>
      ) : (
        ""
      )}
      <strong>
        {transformPrice(installmentPrice || retailPrice)}
        {installmentPrice ? "/" + i18n.t("MONTH_SHORT") : ""}
      </strong>
    </span>
  );
};
